import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TruncateModule } from '@pipes/truncate-pipe/turncate.module';
import { PipeDirectiveModule } from '@shared-modules/pipe-directive.module';
import { TooltipModule } from 'primeng/tooltip';
import { ReMultiselectComponent } from './re-multiselect.component';
import { TurncatePipeModule } from '@pipes/truncate-lines.module';

@NgModule({
  imports: [CommonModule, NgSelectModule, FormsModule, TruncateModule, PipeDirectiveModule, TooltipModule, TurncatePipeModule],
  declarations: [ReMultiselectComponent],
  exports: [ReMultiselectComponent],
  providers: [DatePipe],
})
export class ReMultiselectModule {}
